import React from "react";
import {useAppSelector, useAppDispatch} from 'redux/hooks'
import {Button} from "primereact/button";
import {getAudioControlPermissions} from "../../../../redux/permissions/permissionsUtils";
import {
    initialAudioControlData,
    setArchiveAudioControlTableToggle,
    setAudioControlClearFilters,
    setAudioControlDialogVisible,
    setAudioControlErrorField,
} from "../../../../redux/actions/actionsAudioControl";
import {setEditType} from "../../../../redux/actions/actions";

const AudioControlListNav = (props: any) => {
    const dispatch = useAppDispatch()
    const archiveTableToggle = useAppSelector(state => state.AudioControlListReducer.archiveAudioControlTableToggle)
    const rolesVision = useAppSelector(state => state.RolesReducer.rolesVision) as unknown as Record<string, string[]>;
    const audioControlPermissions = getAudioControlPermissions(rolesVision);

    const {
        create: hasCreatePermission,
    } = audioControlPermissions;

    return (
        <div className="table-buttons">
            <div>
                <Button onClick={() => {
                    dispatch(setArchiveAudioControlTableToggle(true))
                }}
                        label="Аудіоконтроль"
                        className={archiveTableToggle ? 'mr-2 mb-2' : 'p-button-secondary mr-2 mb-2'}
                />
                <Button onClick={() => {
                    dispatch(setArchiveAudioControlTableToggle(false))
                }}
                        label="Архів"
                        className={archiveTableToggle ? 'p-button-secondary mr-2 mb-2' : 'mr-2 mb-2'}
                />
            </div>
            <div className="desktop">
                {hasCreatePermission && (<Button label="Створити"
                                                 icon="pi pi-plus"
                                                 className="mr-2 mb-2"
                                                 onClick={() => {
                                                     dispatch(initialAudioControlData());
                                                     dispatch(setAudioControlDialogVisible(true));
                                                     dispatch(setAudioControlErrorField(null));
                                                     props.setSelectedRowData(null);
                                                     dispatch(setArchiveAudioControlTableToggle(true));
                                                     if (hasCreatePermission) {
                                                         dispatch(setEditType(true));
                                                     } else {
                                                         dispatch(setEditType(false));
                                                     }
                                                 }}
                />)}
                <Button type="button" icon="pi pi-filter-slash" label="Очистити фільтри" className="p-button-outlined mr-2 mb-2" onClick={() => {
                    dispatch(setAudioControlClearFilters());
                    props.handleReset()
                }}/>
            </div>
            <div className="mobile">
                {hasCreatePermission && (
                    <Button icon="pi pi-plus"
                            className="mr-2 mb-2"
                            onClick={() => {
                                dispatch(setAudioControlErrorField(null));
                                dispatch(initialAudioControlData());
                                dispatch(setAudioControlDialogVisible(true));
                                props.setSelectedRowData(null);
                                dispatch(setArchiveAudioControlTableToggle(true));
                                if (hasCreatePermission) {
                                    dispatch(setEditType(true));
                                } else {
                                    dispatch(setEditType(false));
                                }
                            }}
                    />)}
                <Button type="button" icon="pi pi-filter-slash" className="p-button-outlined mr-2 mb-2" onClick={() => dispatch(setAudioControlClearFilters())}/>
            </div>
        </div>
    )
}

export default AudioControlListNav
